import React from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import ProgressBar from "../../layouts/ProgressBar";

export default function ReusableProgessBar({children}) {
    const location = useLocation();
    const formPaths = ['/personal-details', '/contact-details', '/educational-details', '/professional-ref', '/additional-details'];
    const currentStep = formPaths.indexOf(location.pathname);
  
    return (
      <>
        <ProgressBar currentStep={currentStep} />
        <div>{children}</div>
      </>
    );
};

ReusableProgessBar.propTypes = {
    children: PropTypes.node.isRequired
};
